let listChecked = [];
if(document.querySelector('[checklistandshow]')){
    let checkListAndShowList = document.querySelectorAll('[checklistandshow]');
    let form = document.querySelector('[checklistandshow]').closest('form').name;
    let listAllInputs = {};
    let listMap = {};

    checkListAndShowList.forEach(listElement =>{
        /** split text on name group and elements */
        let listElementSplit = listElement.getAttribute('checklistandshow').match(/^([^()]+)\(([^]+)\)$/)
        addToGroup(listMap, listElementSplit[1], listElementSplit[2]);
        listElement.classList.add('d-none');
    });
    Object.entries(listMap).forEach(([group, elements]) => {
        let list = [];
        elements.forEach(listElement => {

            let listElementToCheck = listElement.split(',');
            listElementToCheck.forEach(field =>{
               let result = field.match(/^(.*?)\[(.*?)\]$/);
               let fieldName = result[1];
               let fieldValue = result[2];
                listAllInputs[group]=getListAllInputs(form, fieldName, list);
            });

            Object.values(listAllInputs).forEach(gr => {
                gr.forEach(input => {
                    input.addEventListener('change', function () {
                        let findElement = document.querySelector('[checklistandshow="'+group+'('+listElement+')"]');
                        if(listCheckedValuesAndCompare(listAllInputs[group], listElementToCheck)){
                            findElement.classList.remove('d-none');
                        }
                        else{
                            findElement.classList.add('d-none');
                        }
                        countElementNotHide(group, listElementToCheck)
                    });
                });
            });
        });
    });
}

function countElementNotHide(nameGroup, test){
    let getAllElementsHideFromGroup = document.querySelectorAll(`[checklistandshow^="${nameGroup}"]`);
    let itemsWithoutDNone = Array.from(getAllElementsHideFromGroup).filter(element => !element.classList.contains('d-none'));

    if(itemsWithoutDNone.length > 1){
        let longestTab = retunLongestTab(itemsWithoutDNone)
        let elementToShow = document.querySelector(`[checklistandshow="${nameGroup}(${longestTab})"]`);
        itemsWithoutDNone.forEach(el =>{
            if (el !== elementToShow){
                el.classList.add('d-none');
            }
        });
    }
    /** This is moment when it was in if above, i.e. there is one single-element array and the value appears in another array   */
    else if(itemsWithoutDNone.length === 0){
        let arraysSingleElementChecked = listChecked.map(element => [element]);

        arraysSingleElementChecked.forEach(singleElementChecked=>{

            getAllElementsHideFromGroup.forEach(el =>{
                let splitEl = el.getAttribute('checklistandshow').match(/^([^()]+)\(([^]+)\)$/);
                let listElementToCheck = splitEl[2].split(',');
                if(compareTabs(singleElementChecked, listElementToCheck)){
                    el.classList.remove('d-none');
                }
            });

        });

    }
}
function retunLongestTab(array){
    let longestTab = [];

    array.forEach(el =>{
        let splitEl = el.getAttribute('checklistandshow').match(/^([^()]+)\(([^]+)\)$/);
        let currentTab = splitEl[2].split(',');
        if (currentTab.length > longestTab.length) {
            longestTab = currentTab;
        }
    });

    return longestTab;
}
function addToGroup(nameList, group, elements) {
    /** If the group already exists, add new items to the existing list */
    if (nameList.hasOwnProperty(group)) {
        nameList[group].push(elements);
    } else {
        nameList[group] = [elements];
    }
}

function getListAllInputs(form, fieldName, list){
    let listInput = document.querySelectorAll( '[name="' + form + '[' + fieldName + ']"]');
    listInput.forEach(input =>{
        if(!list.includes(input)){
            list.push(input)
        }
    });
    return list;
}
function listCheckedValuesAndCompare(list, listElementToCheck){
    listChecked = [];
    let foundMatch = false;
    list.forEach(input =>{
        if(input.checked){
            let splitName = (input.name).match(/^(.*?)\[(.*?)\]$/);
            let valueName = splitName[2] + "["+ input.value + "]";

            if(!listChecked.includes(valueName)){
                listChecked.push(valueName)
            }

            if(compareTabs(listChecked, listElementToCheck)){
                foundMatch = true;
            }
        }
    });
    return foundMatch;
}
function compareTabs(tab1, tab2) {
    if (tab1.length !== tab2.length) {
        return false;
    }

    let sortTab1 = tab1.slice().sort();
    let sortTab2 = tab2.slice().sort();

    let isTheSame = true;
    sortTab1.forEach(function(element, index) {
        if (element !== sortTab2[index]) {
            isTheSame = false;
        }
    });

    return isTheSame;
}